/**
 * 주소의 `?t=` 토큰을 한 번만 읽고 주소창·방문 기록에서 지운다(Referer 로도 새지 않게) — 초대·결제 링크가 쓴다.
 *
 * `persistKey` 를 주면 그 탭의 sessionStorage 에 남겨 **새로고침해도** 이어진다. 카카오톡 인앱 브라우저는 앱을
 * 오가면 페이지를 다시 읽는데, 주소에서 토큰을 지운 뒤라 그대로면 화면이 「올바르지 않은 주소」가 된다
 * (261020-pay-link). 다 쓰면 `clearUrlToken(persistKey)` 로 지운다
 */
import { useRef } from 'react';

function storage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

export function useUrlToken(persistKey?: string): string {
  const ref = useRef<string | null>(null);
  if (ref.current === null) {
    const fromUrl = new URLSearchParams(window.location.search).get('t') ?? '';
    if (fromUrl) {
      window.history.replaceState(null, '', window.location.pathname);
      if (persistKey) {
        try {
          storage()?.setItem(persistKey, fromUrl);
        } catch {
          // 저장을 못 하면 새로고침에서 끊길 뿐이다
        }
      }
      ref.current = fromUrl;
    } else {
      ref.current = (persistKey && storage()?.getItem(persistKey)) || '';
    }
  }
  return ref.current;
}

export function clearUrlToken(persistKey: string): void {
  try {
    storage()?.removeItem(persistKey);
  } catch {
    // 무시 — 탭을 닫으면 사라진다
  }
}
